import React, {
  useState,
  useEffect,
  useCallback,
  Fragment,
  useContext
} from "react";
import PropTypes from "prop-types";
import Swiper from "react-id-swiper";
import BrandPage from "containers/brand/BrandPage";
import masker from "assets/img/bg/bg@2x.png";
// Version >= 2.4.0
// import "swiper/css/swiper.css";
import "./vertical-page-swiper.scss";
import Loadable from "react-loadable";
import { AppContext } from "@/Context";
import IndexPage from "containers/promotion-index/Index";
const ConditionPage = Loadable({
  loader: () => import("containers/promotion-condition/ConditionPage"),
  loading() {
    return <div></div>;
  }
});
const AboutPage = Loadable({
  loader: () => import("containers/promotion-about/AboutPage"),
  loading() {
    return <div></div>;
  }
});
// const IndexPage = Loadable({
//   loader: () => import("containers/promotion-index/Index"),
//   loading() {
//     return <div></div>;
//   }
// });
const VerticalSlider = props => {
  const { state, dispatch } = useContext(AppContext);
  const [pageNextIcon, setPageNextIcon] = useState(true);
  const [swiperHeight, setSwiperHeight] = useState(window.innerHeight);
  const tempMode = state.tempMode;
  const noBrand = state.noBrand;
  const defaultCommonCfg = {
    containerClass: `page-vertical-swiper-container ${tempMode === "edit" &&
      "edit-mode"}`,
    mousewheel: true,
    shortSwipes: false,
    longSwipesMs: 100,
    longSwipesRatio: 0.08,
    resistanceRatio: 0,
    height: window.innerHeight,
    // lazy: {
    //   loadPrevNext: true
    // },
    effect: "slide",

    shouldSwiperUpdate: true,
    rebuildOnUpdate: true
    // observer: true,//修改swiper自己或子元素时，自动初始化swiper
    // observeParents: true,//修改swiper的父元素时，自动初始化swiper
  };
  const swiperCfg = useCallback(() => {
    return Object.assign(
      {},
      defaultCommonCfg,
      tempMode === "edit"
        ? {
            // 编辑模式
            direction: "horizontal",
            rebuildOnUpdate: true,
            loop: false,
            centeredSlides: true,
            slidesOffsetBefore: 50,
            // slidesOffsetAfter: 50,
            width: window.innerWidth - 100,
            spaceBetween: 25
          }
        : {
            loop: true,
            direction: "vertical",
            // initialSlide: 0,
            // observer: true, //修改swiper自己或子元素时，自动初始化swiper
            // observeParents: true, //修改swiper的父元素时，自动初始化swiper
            // observeSlideChildren:true,
            // navigation: {
            //   nextEl: ".vertical-page-swiper-next"
            // },
            // renderNextButton: () =>
            //   pageNextIcon ? (
            //     <div className="vertical-page-swiper-next"></div>
            //   ) : (
            //     ""
            //   ),
            on: {}
          }
    );
  }, [pageNextIcon, tempMode]);
  const [params, setParams] = useState(swiperCfg());
  const [swiper, setSwiper] = useState(null);
  const [brandShown, setBrandShown] = useState(false);
  window.pageNoBrand = false;
  useEffect(() => {
    if (swiper) {
      setTimeout(() => {
        window.document.documentElement.scrollTop = 0;
      });
    }
    return () => {
      if (swiper) {
        swiper.off("touchEnd");
        swiper.off("slideChangeTransitionEnd");
      }
    };
  }, [swiper]);
  useEffect(() => {
    setTimeout(() => {
      var myEvent = new Event("resize");
      window.dispatchEvent(myEvent);
    });
    let params = swiperCfg();
    setParams(Object.assign({}, params));
    if (params.rebuildOnUpdate) {
      setTimeout(() => {
        params.rebuildOnUpdate = false;
        setParams({ ...params });
      }, 10);
    }
  }, [pageNextIcon, swiperCfg, swiper]);
  useEffect(() => {
    window.pageNoBrand = noBrand;
  });

  const getSwiper = swiper => {
    setSwiper(swiper);
    swiper.on("slideChangeTransitionEnd", event => {
      console.log(swiper.realIndex);
      console.log(swiper.activeIndex);
      console.log(swiper.slides.length);
      if (swiper.realIndex !== swiper.slides.length - 1) {
        swiper.$el.removeClass("masked");
        setPageNextIcon(true);
      } else {
        setPageNextIcon(false);
      }
    });
    swiper.on("touchEnd", event => {
      console.log(swiper.realIndex);
      console.log(swiper.activeIndex);
      console.log(swiper.slides.length);
      /**
       * diff为负，代表正向滑动
       * isEnd 代表已经是最后一张（最后一张取消弹动效果）
       * diff/height >= longSwipersRatio 代表正向滑动距离超过可以滚动的最小距离，可以滚动页面
       *
       * swiper.touches.diff 在短点时， 不会变动，插件有bug ， 这里采用两者相减即可
       */
      if (!window.pageNoBrand) {
        let diff = swiper.touches.currentY - swiper.touches.startY;
        if (
          swiper.realIndex === swiper.slides.length - 1 &&
          diff < 0 &&
          Math.abs(diff) / swiper.height >= swiper.params.longSwipesRatio
        ) {
          console.log("lastest page shown");
          swiper.$el.addClass("masked");
          setPageNextIcon(false);
          setBrandShown(true);
          // if (document.querySelector(".page-brand")) {
          //   document
          //     .querySelector(".page-brand")
          //     .removeEventListener("touchstart", touchStart);
          //   document
          //     .querySelector(".page-brand")
          //     .addEventListener("touchstart", touchStart, false);
          // }
        }
      } else {
        swiper.$el.removeClass("masked");
        setPageNextIcon(true);
        setBrandShown(false);
      }
    });
  };
  return (
    <Fragment>
      <Swiper {...params} getSwiper={getSwiper}>
        <div style={{ height: "100vh", maxHeight: swiperHeight + "px" }}>
          <IndexPage />
        </div>
        <div style={{ height: "100vh", maxHeight: swiperHeight + "px" }}>
          <ConditionPage />
        </div>
        <div style={{ height: "100vh", maxHeight: swiperHeight + "px" }}>
          <AboutPage />
          <img
            className={`filter-masker ${brandShown ? "filter-shown" : ""}`}
            src={masker}
            alt=""
          />
        </div>
        {!noBrand && tempMode !== "edit" ? (
          <div style={{ height: "100vh", maxHeight: window.innerHeight + "px" }}>
            <BrandPage shown={true}></BrandPage>
          </div>
        ) : (
          <Fragment></Fragment>
        )}
      </Swiper>
      {tempMode !== "edit" && pageNextIcon && <div class="vertical-page-swiper-next"></div>}
    </Fragment>
  );
};
VerticalSlider.propTypes = {
  swiperNextOnEnd: PropTypes.func
};
export default VerticalSlider;
